import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'react-magma-dom';
import { UploadIcon } from 'react-magma-icons';


const UploadTrigger = props => {
  const { onOpenModal } = props;
  return (
    <div style={{ width: '100%' }} className="upload-files min-width-150">
      <IconButton
        isFullWidth
        style={{ fontSize: 14, width: '100%' }}
        aria-label="Upload"
        icon={<UploadIcon />}
        onClick={onOpenModal}
      >
        Upload CSV
      </IconButton>
    </div>
  );
};

UploadTrigger.propTypes = {
  onOpenModal: PropTypes.func.isRequired
};

export default UploadTrigger;
